import React from 'react';
import { useTranslation } from 'react-i18next';

const TEXT = {
  es: {
    title: 'Revisa tu cat\u00e1logo',
    zeroCost: '{{count}} producto(s) con costo 0',
    negative: '{{count}} producto(s) con margen negativo (el costo supera el precio)',
    lowMargin: '{{count}} producto(s) con margen menor del 5 %',
    hint: 'Son datos v\u00e1lidos pero sospechosos. Corr\u00edgelos si son un error, para que tu ganancia real sea fiable.',
  },
  en: {
    title: 'Review your catalog',
    zeroCost: '{{count}} product(s) with a cost of 0',
    negative: '{{count}} product(s) with a negative margin (cost is higher than price)',
    lowMargin: '{{count}} product(s) with a margin below 5%',
    hint: 'These values are valid but suspicious. Fix them if they are mistakes, so your real profit stays reliable.',
  },
  fr: {
    title: 'V\u00e9rifiez votre catalogue',
    zeroCost: '{{count}} produit(s) avec un co\u00fbt de 0',
    negative: '{{count}} produit(s) avec une marge n\u00e9gative (le co\u00fbt d\u00e9passe le prix)',
    lowMargin: '{{count}} produit(s) avec une marge inf\u00e9rieure \u00e0 5 %',
    hint: 'Ces valeurs sont valides mais suspectes. Corrigez-les s\u2019il s\u2019agit d\u2019erreurs, pour un b\u00e9n\u00e9fice r\u00e9el fiable.',
  },
};

const getText = (lang) => TEXT[(lang || 'es').slice(0, 2)] || TEXT.es;
const toNumber = (value) => (value === null || value === undefined || value === '' ? null : Number(value));

function CatalogHealth({ products }) {
  const { i18n } = useTranslation();
  const tx = getText(i18n.language);
  const zero = [];
  const negative = [];
  const low = [];
  (products || []).forEach((p) => {
    const cost = toNumber(p.cogs);
    const price = toNumber(p.sale_price);
    if (price === null || !(price > 0)) return;
    if (!cost) zero.push(p.sku);
    else if (cost > price) negative.push(p.sku);
    else if ((price - cost) / price < 0.05) low.push(p.sku);
  });
  const groups = [[zero, tx.zeroCost], [negative, tx.negative], [low, tx.lowMargin]].filter(([list]) => list.length > 0);
  if (groups.length === 0) return null;
  return (
    <div className="bg-[#2a1f0f] border border-[#7f5f1d] rounded-lg p-4 mb-6">
      <p className="text-amber-400 text-sm font-semibold mb-2">{tx.title}</p>
      {groups.map(([list, label]) => (
        <p key={label} className="text-amber-400 text-sm">
          {label.replace('{{count}}', list.length)}:{' '}
          <span className="font-mono">{list.slice(0, 5).join(', ')}{list.length > 5 ? ' \u2026' : ''}</span>
        </p>
      ))}
      <p className="text-muted text-xs mt-2">{tx.hint}</p>
    </div>
  );
}

export default CatalogHealth;